import { logger } from '../utilities/logger';
import { POST_TOKEN_EVENT_KEY } from '../app/hooks/use_post_token';
import { PREFERRED_LANGUAGE_EVENT_KEY } from '../app/hooks/use_language_preference';
import { INITIALISE_EVENT_KEY } from '../app/hooks/use_initialise';
import { DEEP_LINK_POST_EVENT_KEY } from '../app/hooks/use_deep_link_post';
import { APP_EVENT } from '../contexts/app_state/app_state.constants';

export const FeedsWebViewApi = {
  postToken(token: string, expire: string): void {
    logger.debug({ message: 'FeedsWebViewApi postToken', extra: { token, expire } });
    window.dispatchEvent(new CustomEvent(POST_TOKEN_EVENT_KEY, { detail: { token, expire } }));
  },
  setPreferredLanguage(locale: string): void {
    logger.debug({ message: 'FeedsWebViewApi setPreferredLanguage', extra: { locale } });
    window.dispatchEvent(new CustomEvent(PREFERRED_LANGUAGE_EVENT_KEY, { detail: { locale } }));
  },
  // eslint-disable-next-line max-params
  initialise(token: string, expire: string, locale: string, apiEndpoint: string, route: string) {
    logger.debug({
      message: 'FeedsWebViewApi initialise',
      extra: { token, expire, locale, apiEndpoint, route },
    });
    window.dispatchEvent(
      new CustomEvent(INITIALISE_EVENT_KEY, {
        detail: { token, expire, locale, apiEndpoint, route },
      })
    );
  },
  deepLinkPost(uri: string): void {
    logger.debug({ message: 'FeedsWebViewApi deepLinkPost', extra: { uri } });
    window.dispatchEvent(new CustomEvent(DEEP_LINK_POST_EVENT_KEY, { detail: { uri } }));
  },

  willSuspend(): void {
    logger.debug({ message: 'FeedsWebViewApi willSuspend' });
    window.dispatchEvent(new CustomEvent(APP_EVENT.willSuspendEventKey));
  },

  didResume(): void {
    logger.debug({ message: 'FeedsWebViewApi didResume' });
    window.dispatchEvent(new CustomEvent(APP_EVENT.didResumeEventKey));
  },
};

export function initFeedsWebViewApi(): void {
  if (window.FeedsWebViewApi) {
    logger.debug({ message: 'FeedsWebViewApi already initialized' });
  } else {
    window.FeedsWebViewApi = FeedsWebViewApi;
    logger.debug({ message: 'FeedsWebViewApi initialized' });
  }
}
